import { useNavigate, useLocation } from "react-router-dom";
import type { NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";
import PageTransition from '../components/layout/PageTransition';

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const navigate = useNavigate();
  const location = useLocation();
  const element = useRoutes(routes);

  useEffect(() => {
    if (!window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE = navigate;
      navigateResolver(window.REACT_APP_NAVIGATE);
    }
  }, [navigate]);


  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'ROUTE_CHANGE',
        path: location.pathname,
      }));
      console.log('[Router] ROUTE_CHANGE 전송:', location.pathname);
    }
  }, [location.pathname]);

  return <PageTransition>{element}</PageTransition>;
}